import ToggleSwitch from "@components/Home/ToggleSwitchLang/ToggleSwitchLang";
import { Stack } from "@mui/material";
import { StackLogo, Title } from "@pages/auth/login/Login.style";
import LoginForm from "@pages/auth/login/LoginForm";
import { LogoLetter } from "assets/icons/LogoLetter";
import React from "react";
import { useTranslation } from "react-i18next";
const Login = () => {
  const { t } = useTranslation();
  return (
    <Stack>
      <ToggleSwitch />

      <StackLogo>
        <StackLogo>
          <LogoLetter />
          <Title>{t("login.title")}</Title>
        </StackLogo>
        <LoginForm />
      </StackLogo>
    </Stack>
  );
};

export default Login;
